import { apiClient } from '../Api';

/**
 * Service de base abstrait inspiré de Pohsa BaseService.ts
 */
export abstract class BaseService<TDto = any> {
  protected readonly endpoint: string;

  constructor(endpoint: string) {
    this.endpoint = endpoint;
  }

  async get<T = TDto>(path: string = '', options?: RequestInit): Promise<T> {
    return apiClient.get<T>(`${this.endpoint}${path}`, options);
  }

  async post<T = TDto>(path: string = '', data?: any, options?: RequestInit): Promise<T> {
    return apiClient.post<T>(`${this.endpoint}${path}`, data, options);
  }

  async put<T = TDto>(path: string = '', data?: any, options?: RequestInit): Promise<T> {
    return apiClient.put<T>(`${this.endpoint}${path}`, data, options);
  }

  async delete<T = TDto>(path: string = '', options?: RequestInit): Promise<T> {
    return apiClient.delete<T>(`${this.endpoint}${path}`, options);
  }
}
